import { calibrationConstants } from './calibration-constants';

const { cardHeightMm, circleDimensionsReferenceMm } = calibrationConstants;

export const cardDimensionCalculations = (cardHeightPx, cardWidthPx, screenWidthPx, screenHeightPx) => {
  const pixelDensity = cardHeightMm / cardHeightPx || 0.31;
  const circleDimensionsPx = Math.round(circleDimensionsReferenceMm / pixelDensity);

  const newData = {
    cardDimensions: { widthPx: cardWidthPx, heightPx: cardHeightPx },
    screenWidthPx: screenWidthPx,
    screenHeightPx: screenHeightPx,
    pixelDensity: pixelDensity,
    circleDimensionsPx: circleDimensionsPx,
  };

  return newData;
};

export const rulerDimensionCalculations = (rulerWidthMm, rulerHeightMm, screenWidthPx, screenHeightPx) => {
  const diagonalInMm = Math.sqrt(Math.pow(+rulerWidthMm, 2) + Math.pow(+rulerHeightMm, 2));
  const diagonalInPx = Math.sqrt(Math.pow(screenWidthPx, 2) + Math.pow(screenHeightPx, 2));
  const pixelDensity = diagonalInMm / diagonalInPx;
  const circleDimensionsPx = Math.round(circleDimensionsReferenceMm / pixelDensity);

  let newData = {
    rulerDimensions: { heightMm: +rulerHeightMm, widthMm: +rulerWidthMm },
    screenWidthPx: screenWidthPx,
    screenHeightPx: screenHeightPx,
    pixelDensity: pixelDensity,
    circleDimensionsPx: circleDimensionsPx,
  };

  return newData;
};
